import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { useAuth, useProfileAiSummary } from "hooks";
import { AiSummaryContainer, AiSummaryDisplay } from "components/AiSummary";
import { RATING_RESOURCE_TYPES } from "constants/index";

/**
 * ProfileAiSummary
 *
 * @param {String}  profileId
 * @param {String}  msgId
 * @param {Boolean} loading
 * @param {Boolean} showRatings
 */
const ProfileAiSummary = ({ profileId, loading, msgId, showRatings = true }) => {
  const { isAdmin } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const { data, summaryHash, loading: summaryLoading, error } = useProfileAiSummary(profileId);

  useEffect(() => {
    setIsLoading(loading || summaryLoading);
  }, [loading, summaryLoading]);

  return (
    <AiSummaryContainer
      title={<FormattedMessage id={msgId} />}
      loading={isLoading}
      data={data}
      error={error}
      hideHeader={!msgId}
      itemRenderer={(item, index, loading) => (
        <AiSummaryDisplay
          key={index}
          summary={item?.body}
          loading={loading}
          summaryHash={summaryHash}
          resourceId={profileId}
          resourceType={RATING_RESOURCE_TYPES.profile}
          showRegenerateButton={isAdmin}
          showRatings={showRatings}
        />
      )}
    />
  );
};

ProfileAiSummary.propTypes = {
  profileId: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  showRatings: PropTypes.bool,
  msgId: PropTypes.string,
};

export default ProfileAiSummary;
